// extracted by extract-css-chunks-webpack-plugin
module.exports = {"timerClockDigitInner":"m7k-C","timerFlip":"wS6f6","timerPrevNumber":"g0gaX","timerNextNumber":"lChgh","timerDayLeft":"CR6bP","timerDayText":"IsFxv"};